import { QuestionBase } from "./question-base.model";

export class SearchAndSelect extends QuestionBase<string> {
  controlType = 'searchselect';
  visible: boolean;
  defaultsetting: any;
  datasource: any;
  getterKey: any;
  getterValue: any;
  options: any;
  format: any;
  set_object: any;
  view_key: any;
  placeholder: any;
  index: number;
  popover: string;
  tooltip: any;
  class_conditions: any;
  disabled: any;
  flag: any;
  keys_to_remove: any;
  set_template_block: any;
  req_keys: any;
  stopSorting:any;
  add_fav: any;
  defaultValue: any;
  complexSearch:any;
  // getAssignedFacilityList:any;
  constructor(options: {} = {}) {
    super(options);
    this.visible = (options['visible'] == undefined) ? true : options['visible'];
    this.defaultsetting = options['defaultsetting'];
    this.datasource = options['datasource'];
    this.getterKey = options['getterKey'];
    this.getterValue = options['getterValue'];
    this.options = options['options'];
    this.format = options['format'];
    this.set_object = options['set_object'] || '';
    this.keys_to_remove = options['keys_to_remove'];
    this.set_template_block = options['set_template_block'];
    this.conditions = options['conditions'] || '';
    this.view_key = options['view_key'] || false;
    this.placeholder = options['placeholder'] || '';
    this.index = options['index'];
    this.add_fav = options['add_fav'] || false;
    this.popover = options['popover'];
    this.tooltip = options['tooltip'];
    this.class_conditions = options['class_conditions'] == undefined ? false : options['class_conditions'];
    this.disabled = options['disabled'] == undefined ? false : options['disabled'];
    this.flag = options['flag'] || false;
    this.defaultValue = options['defaultValue'] || '';
    this.req_keys = options['req_keys'];
    this.stopSorting = options['stopSorting'] == undefined ? false : options['stopSorting'];
    this.complexSearch = options['complexSearchFields'] || null;
    // this.getAssignedFacilityList = options['getAssignedFacilityList'] || false;
  }
}
